import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { httpClient } from '../../../shared/api/httpClient'
import { ADMIN_USERS_QUERY_KEY } from '../administrationConstants'

export function useAdminUsersQuery({ enabled = true } = {}) {
  return useQuery({
    queryKey: ADMIN_USERS_QUERY_KEY,
    queryFn: async () => {
      const response = await httpClient.get('/admin/users')
      return response.data
    },
    enabled,
  })
}

export function useUpdateUserPermissionsMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ userId, permissions }) => {
      const response = await httpClient.patch(`/admin/users/${userId}/permissions`, { permissions })
      return response.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ADMIN_USERS_QUERY_KEY })
      queryClient.invalidateQueries({ queryKey: ['currentUser'] })
    },
  })
}
